const pendingForms = new WeakSet();

class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.button = this.closest("button");
    this.form = this.button?.form;

    if (!this.form) return;

    this.onSubmit = (e) => {
      // Only handle submit if this add-to-cart's button was the one clicked
      // (avoids duplicate add-to-cart when form has multiple ATC buttons)
      if (e.submitter !== this.button) return;

      e.preventDefault();

      if (pendingForms.has(this.form)) return;
      if (e.target.querySelector("[data-option-indeterminate]")) return;

      const idInput = this.form.querySelector('input[name="id"]');
      if (!idInput?.value || this.button.disabled) return;

      const formData = new FormData(this.form);

      const data = {};

      // Add each name/value pair to the object
      for (const [name, value] of formData) {
        data[name] = value;
      }

      if (!("quantity" in data)) {
        data.quantity = 1;
      }

      const errorMessage = this.form.querySelector("[data-product-form-error]");
      const submitButtons = [
        ...this.form.querySelectorAll("[data-product-form-atc]"),
      ];
      const disabledStates = new Map(
        submitButtons.map((button) => [button, button.disabled]),
      );
      let selectionChanged = false;
      let latestSelectionAvailable = false;

      const handleVariantChange = (event) => {
        selectionChanged = true;
        latestSelectionAvailable = Boolean(event.detail?.variant?.available);
      };

      const unlockForm = () => {
        pendingForms.delete(this.form);
        this.form.removeAttribute("aria-busy");
        this.form.removeEventListener("variant:changed", handleVariantChange);

        submitButtons.forEach((button) => {
          button.disabled = selectionChanged
            ? !latestSelectionAvailable
            : disabledStates.get(button);
          button.removeAttribute("aria-busy");
        });
      };

      const request = window.addToCart(data, {
        onBeforeAdd: () => {
          pendingForms.add(this.form);
          this.form.addEventListener("variant:changed", handleVariantChange);
          this.form.setAttribute("aria-busy", "true");
          submitButtons.forEach((button) => {
            button.disabled = true;
            button.setAttribute("aria-busy", "true");
          });
          if (errorMessage) errorMessage.hidden = true;
        },
        onAfterAdd: () => {
          document.dispatchEvent(new CustomEvent("mini-cart:open"));
        },
        onError: () => {
          if (errorMessage) errorMessage.hidden = false;
        },
        onFinally: unlockForm,
      });
      request.catch(() => {});
    };

    this.form.addEventListener("submit", this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
  }
}

if (!customElements.get("add-to-cart")) {
  customElements.define("add-to-cart", AddToCart);
}
